import styled, { RuleSet } from 'styled-components'
import { Noto_body1_r16 } from 'src/styles/fonts/NotoSansKrFonts'
import { ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Container } from 'src/components/common/Container'

type UnderLineTabHeaderItems<T> = {
  text: string
  contents: ReactNode
  value: T
}
export interface UnderLineTabProps<T> {
  style?: RuleSet<object>
  items: UnderLineTabHeaderItems<T>[]
  state: { activeTab: T; setActiveTab: (value: T) => void }
}

// underline_tab two items
const UnderLineTab = <T,>({
  items,
  state: { activeTab, setActiveTab },
  style,
}: UnderLineTabProps<T>) => {
  const initialActiveTab = items?.at(0)?.value

  const tabValueHandler = (value: T) => setActiveTab(value)

  const findActiveItems = items?.find((w) => w.value === activeTab)

  return (
    <UnderLineTabWrap $option="flex_column">
      <TabUnderLine />
      <UnderLineTabHeaderWrap $style={style}>
        {items?.map(({ text, value }: UnderLineTabHeaderItems<T>) => (
          <TabItems $active={value === activeTab} onClick={() => tabValueHandler(value)} key={text}>
            {text}
          </TabItems>
        ))}
        <TabItemsActive $direction={activeTab === initialActiveTab ? 'left' : 'right'} />
      </UnderLineTabHeaderWrap>
      <UnderLineTabBodyWrap
        as={!!findActiveItems?.contents ? 'div' : Skeleton}
        $direction={activeTab === initialActiveTab ? 'left' : 'right'}
      >
        {findActiveItems?.contents}
      </UnderLineTabBodyWrap>
    </UnderLineTabWrap>
  )
}
export default UnderLineTab

const UnderLineTabWrap = styled(Container)`
  flex: 1;
  background-color: white;
  position: relative;
`
const UnderLineTabHeaderWrap = styled.section<{ $style?: RuleSet<object> }>`
  display: flex;
  position: relative;
  width: 100%;
  height: 60px;
  ${(props) => props.$style};
`
const TabItems = styled.button<{ $active: boolean }>`
  width: 50%;
  height: 60px;
  ${Noto_body1_r16};
  cursor: pointer;
  color: ${(props) => (props.$active ? 'var(--black-90)' : ' var(--black-50)')};
  background-color: var(--white);
`
const TabUnderLine = styled.span`
  width: 100%;
  height: 1px;
  position: absolute;
  top: 59px;
  background-color: var(--black-10);
  z-index: 1;
`

const TabItemsActive = styled.span<{ $direction: string }>`
  width: 50%;
  height: 2px;
  background-color: var(--black-100);
  top: 58px;
  z-index: 1;
  position: absolute;
  transition: all 0.3s ease-in-out;
  transform: ${(props) => (props.$direction === 'left' ? 'translateX(0)' : 'translateX(100%)')};
`
const UnderLineTabBodyWrap = styled.div<{ $direction: string }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 240px;
  flex: 1;
`
